export default __webpack_public_path__ + "static/media/ABChanelCorpo-SemiBold.ba45dfda.ttf";